module.exports = __webpack_public_path__ + "img/globalgiving.38e8c933.png";